import { ISuggestResponseSchema } from '../../repositories/newbuilding-promos/entities/suggest/SuggestResponseSchema';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ESuggestionsActionTypes {
  Request = 'SUGGESTIONS/REQUEST',
  Success = 'SUGGESTIONS/SUCCESS',
  Failure = 'SUGGESTIONS/FAILURE',
  Reset = 'SUGGESTIONS/RESET',
}

export type TSuggestionsRequest = ITypedReduxAction<ESuggestionsActionTypes.Request>;
export type TSuggestionsSuccess = ITypedReduxAction<ESuggestionsActionTypes.Success, ISuggestResponseSchema>;
export type TSuggestionsFailure = ITypedReduxAction<ESuggestionsActionTypes.Failure>;
export type TSuggestionsReset = ITypedReduxAction<ESuggestionsActionTypes.Reset>;

export const suggestionsRequest: () => TSuggestionsRequest = actionGenerator<ESuggestionsActionTypes.Request>(
  ESuggestionsActionTypes.Request,
);

export const suggestionsSuccess: (suggestResponse: ISuggestResponseSchema) => TSuggestionsSuccess = actionGenerator<
  ESuggestionsActionTypes.Success,
  ISuggestResponseSchema
>(ESuggestionsActionTypes.Success);

export const suggestionsFailure: () => TSuggestionsFailure = actionGenerator<ESuggestionsActionTypes.Failure>(
  ESuggestionsActionTypes.Failure,
);

export const suggestionsReset: () => TSuggestionsReset = actionGenerator<ESuggestionsActionTypes.Reset>(
  ESuggestionsActionTypes.Reset,
);

export type TSuggestionsActions = TSuggestionsRequest | TSuggestionsSuccess | TSuggestionsFailure | TSuggestionsReset;
